// const currentTimeZone = 'Australia/Lord_Howe';
const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default currentTimeZone;
